<template lang="pug">
.columns.is-marginless
  .column.dashboard-sidebar.is-narrow(style="position:fixed; height:100vh")
    aside.menu.dashboard-sidebar-menu
      ul.menu-list
        li
          router-link(to="/dashboard/start")
            span.icon.is-large
              i.fas.fa-home.fa-lg
        //- li
        //-   router-link(to="/dashboard/katalog")
        //-     span.icon.is-large
        //-       i.fas.fa-archive.fa-lg
        hr.has-background-black
        li
          b-tooltip(label="Channel" position="is-right" type="is-light")
            router-link(to="/dashboard/channel")
              span.icon.is-large
                i.fas.fa-tv.fa-lg
        li
          b-tooltip(label="Seiten" position="is-right" type="is-light")
            router-link(to="/dashboard/seiten")
              span.icon.is-large
                i.fas.fa-map.fa-lg
        li
          b-tooltip(label="Mobile Seiten" position="is-right" type="is-light")
            router-link(to="/dashboard/mobile-seiten")
              span.icon.is-large
                i.fas.fa-mobile-alt.fa-lg
        li
          b-tooltip(label="Module" position="is-right" type="is-light")
            router-link(to="/dashboard/module")
              span.icon.is-large
                i.fas.fa-th.fa-lg
        hr.has-background-black
        li
          b-tooltip(label="Bilder" position="is-right" type="is-light")
            router-link(to="/dashboard/bilder")
              span.icon.is-large
                i.far.fa-images.fa-lg
        li
          b-tooltip(label="Videos" position="is-right" type="is-light")
            router-link(to="/dashboard/videos")
              span.icon.is-large
                i.fas.fa-film.fa-lg
        hr.has-background-black
        li
          b-tooltip(label="Account" position="is-right" type="is-light")
            router-link(to="/dashboard/profil")
              span.icon.is-large
                i.far.fa-user-circle.fa-lg
    aside.menu.dashboard-sidebar-logout
      ul.menu-list
        li
          router-link(to="/login")
            span.icon.is-large
              i.fas.fa-power-off.fa-lg
  .column(style="min-height:100vh;display:flex; flex-direction:column;" class="is-paddingless")
    router-view
    dashboard-footer
</template>

<script>

  import AlertBottom from '@/components/AlertBottom';
  import DashboardFooter from '@/components/DashboardFooter';

  export default {
    name: 'dashboard',
    data: function () {
      return {

      }
    },
    components: {
      AlertBottom,
      DashboardFooter
    },
    mounted() {
      // TELL VUEX STORE TO FETCH USER DATA
      this.$store.dispatch('user/USER_FETCH');
      this.$store.dispatch('assets/ASSETS_FETCH');
      this.$store.dispatch('assets/IMAGES_FETCH');
      this.$store.dispatch('players/FETCH');
      this.$store.dispatch('organization/FETCH');
      this.$store.dispatch('organization/FETCHPUBLIC');

    }
  }
</script>

<style scoped>

  .dashboard-sidebar {
    background: linear-gradient(180deg, #24363F 0%, #1B2A32 100%);
    border-right: 1px solid rgba(255, 255, 255, 0.06);
    z-index: 20;
  }

  .dashboard-sidebar-menu {
    padding-top: 14px;
  }

  .dashboard-sidebar-menu li {
    display: flex;
    justify-content: center;
  }

  .dashboard-sidebar-menu hr {
    background-color: rgba(255, 255, 255, 0.09) !important;
    height: 1px;
    margin: 14px 18px;
  }

  .dashboard-sidebar-logout {
    position: absolute;
    bottom: 14px;
  }

  .dashboard-sidebar-logout li a {
    background: rgba(255, 255, 255, 0.06);
    border-radius: 12px;
    color: rgba(255, 255, 255, 0.65);
    transition: background-color 0.18s ease, color 0.18s ease;
  }

  .dashboard-sidebar-logout li a:hover {
    background: var(--ois-accent, #FF0266);
    color: #fff;
  }

  /* Nav items — rounded targets with an accent pill when active */
  .dashboard-sidebar-menu li a {
    position: relative;
    color: rgba(255, 255, 255, 0.62);
    border-radius: 12px;
    margin: 3px 0;
    transition: background-color 0.18s ease, color 0.18s ease;
  }

  .dashboard-sidebar-menu li a:hover {
    color: #fff;
    background: rgba(255, 255, 255, 0.08);
  }

  .dashboard-sidebar-menu li a.router-link-active,
  .dashboard-sidebar-menu li a.router-link-active:hover {
    color: var(--ois-accent, #FF0266);
    background: rgba(255, 2, 102, 0.14);
  }

  .dashboard-sidebar-menu li a.router-link-active::before {
    content: "";
    position: absolute;
    left: -14px;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 22px;
    border-radius: 0 3px 3px 0;
    background: var(--ois-accent, #FF0266);
  }

</style>
